import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor } from '../../../util/theme';

const FormSubmitWrapper = styled.div`
  border: 1px solid ${getColor('accentRed')};

  background-color: ${getColor('primaryBlue')};

  margin: 20px auto;
  padding: 5px;

  height: 50px;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  &:hover {
    border: 1px solid ${getColor('accentGreen')};

    input {
      background-color: ${getColor('accentGreen')};

      color: ${getColor('primaryBlue')};
    }
  }

  @media (min-width: ${getBreakpoint('md')}) {
    width: 65%;
  }
`;

export default FormSubmitWrapper;
